import styles from "./styles/ReportsHeader.module.scss";

export default function FollowUpHeader() {
  return (
    <>
      <span className={styles.header}>پیگیری ها</span>
    </>
  );
}
